import { render, staticRenderFns } from "./GridCalendar.vue?vue&type=template&id=97d5a996&scoped=true"
import script from "./GridCalendar.vue?vue&type=script&lang=js"
export * from "./GridCalendar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "97d5a996",
  null
  ,true
)

export default component.exports